

















      import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import StoreComponent from '@/app/shared/components/store-component.vue';
import { CourseAspect, File } from '@/app/shared/models';
import aspectStoreModule from '@/app/aspect/apsect-state';
import {TranslateResult} from 'vue-i18n';
import i18n from '@/plugins/i18n';
import { lazyInject } from '@/app/container';
import FileComponent, { FileDetails } from '@/app/file/ui/file-component.vue';

@Component({
  components: {
    StoreComponent,
  }
})
export default class DocumentsComponent extends Vue {
  @Prop()
  public open: boolean;
  
  @Prop()
  public allFiles: File[];
  
  public files: File[] = [];
  
  private renderedFileComponents: Vue[] = [];
  
  public get filterCount(): number {
    return this.files.length;
  }
  
  public get aspect(): CourseAspect|null {
    return aspectStoreModule.selectedCourseAspectInstance;
  }
  
  public mounted(): void {
    this.files = this.allFiles;
  }
  
  @Watch('open')
  public onOpenChanged(newValue: boolean): void {
    if (!newValue) {
      this.setDefaultState();
    }
  }
  
  @Watch('allFiles')
  public onAllFilesChanged(newValue: File[]): void {
    this.files = newValue;
  }
  
  @Watch('aspect')
  public onAspectChanged(newValue: CourseAspect|null): void {
    if (newValue !== null) {
      this.files = this.allFiles;
    }
  }
  
  @Watch('files')
  public onFilesChanged(newValue: File[]): void {
    // TODO: itt jo volna valami egyedi azonosito a fileoknak, hogy ne kelljen az osszeset destroyolni es ujra letrehozni hanem csak a diffet.
    // vegsosorban a file uri lehet akar egyedi, de nem zarhato ki hogy ugyan azzal az uri-vel viszont kulon sorkent mas nevvel kerul be egy file
    this.destroyAllFiles();
    this.createAllFiles();
  }
  
  @Emit('closeModal')
  public emitCloseModal(): void {
    this.setDefaultState();
  }
  
  public t(key: string): TranslateResult {
    return i18n.t(key);
  }
  
  private filter(search: string): void {
    if (search === '') {
      this.files = this.allFiles;
    } else {
      this.files = this.allFiles.filter((f) => {
        return f.title.toLocaleLowerCase().indexOf(search) > -1
              || (f.description !== null && f.description.toLocaleLowerCase().indexOf(search) > -1);
      });
    }
  }
  
  private setDefaultState(): void {
    this.filter('');
  }
  
  private createAllFiles() {
    this.files.forEach(file => {
      
      const fileDetails: FileDetails = {
        uri: file.uri,
        mimeType: file.mimeType,
        title: file.title,
        description: file.description || '',
        size: file.size,
        originalFilename : file.originalFilename,
      }
      
      const component = new FileComponent({
        propsData: {
          content: fileDetails
        }
      })
      
      component.$mount();

      (this.$refs['files-container'] as HTMLDivElement).appendChild(component.$el);

      this.renderedFileComponents.push(component);
    });
    }

    private destroyAllFiles() {
      this.renderedFileComponents.forEach(component => {
        component.$el.parentNode?.removeChild(component.$el);
        component.$destroy();
      });
      this.renderedFileComponents = [];
    }

    private beforeDesroy() {
      this.destroyAllFiles();
    }
  }
